var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLootItemBorder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 185,
    height: 5,
    viewBox: "0 0 185 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81 2H47V4H81V2Z",
    fill: "#1F2933"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8166 2.30127H1.4231V3.22138H41.8166V2.30127Z",
    fill: "#1F2933"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.25894 3.79595C1.83328 3.79595 2.29887 3.33035 2.29887 2.75601C2.29887 2.18166 1.83328 1.71606 1.25894 1.71606C0.684592 1.71606 0.218994 2.18166 0.218994 2.75601C0.218994 3.33035 0.684592 3.79595 1.25894 3.79595Z",
    fill: "#1F2933"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8165 3.79595C42.3909 3.79595 42.8565 3.33035 42.8565 2.75601C42.8565 2.18166 42.3909 1.71606 41.8165 1.71606C41.2422 1.71606 40.7766 2.18166 40.7766 2.75601C40.7766 3.33035 41.2422 3.79595 41.8165 3.79595Z",
    fill: "#1F2933"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47 1.83276L48.4674 0H65.2609L67 2.17216C67 2.17216 50.3152 3.12249 50.0978 2.98673C49.8804 2.85097 47 1.83276 47 1.83276Z",
    fill: "#1F2933"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3889 2L80.4458 2.06122L82.1521 3.89796H90.9682C90.9682 3.89796 92.1058 5 91.992 5C91.8782 5 79.6495 5 79.6495 5L78 3.22449L80.3889 2Z",
    fill: "#1F2933"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M104 2H138V4H104V2Z",
    fill: "#1F2933"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M143.183 2.30127H183.577V3.22138H143.183V2.30127Z",
    fill: "#1F2933"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M183.741 3.79595C183.167 3.79595 182.701 3.33035 182.701 2.75601C182.701 2.18166 183.167 1.71606 183.741 1.71606C184.315 1.71606 184.781 2.18166 184.781 2.75601C184.781 3.33035 184.315 3.79595 183.741 3.79595Z",
    fill: "#1F2933"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M143.183 3.79595C142.609 3.79595 142.144 3.33035 142.144 2.75601C142.144 2.18166 142.609 1.71606 143.183 1.71606C143.758 1.71606 144.223 2.18166 144.223 2.75601C144.223 3.33035 143.758 3.79595 143.183 3.79595Z",
    fill: "#1F2933"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M138 1.83276L136.533 0H119.739L118 2.17216C118 2.17216 134.685 3.12249 134.902 2.98673C135.12 2.85097 138 1.83276 138 1.83276Z",
    fill: "#1F2933"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M104.611 2L104.554 2.06122L102.848 3.89796H94.0318C94.0318 3.89796 92.8942 5 93.008 5C93.1218 5 105.351 5 105.351 5L107 3.22449L104.611 2Z",
    fill: "#1F2933"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLootItemBorder);
export default __webpack_public_path__ + "static/media/lootItemBorder.045280fbfd3226de36a85d001808a37d.svg";
export { ForwardRef as ReactComponent };